import React, {useState} from "react";
import "../styles/StudentCreateForm.css";

export default function StudentCreateForm() {
    const [form, setForm] = useState({
        name: "",
        lastName: "",
        email: "",
        countryCode: "+90",
        phone: "",
        password: "",
        isEnabled: false
    });

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setForm({...form, [name]: type === "checkbox" ? checked : value});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            firstName: form.name,
            lastName: form.lastName,
            email: form.email,
            phone: `${form.countryCode}${form.phone}`,
            password: form.password
        };
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/signup`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                alert("Öğrenci başarıyla eklendi!");
            } else {
                alert("Hata: " + (await response.text()));
            }
        } catch (err) {
            alert("Hata: " + err.message);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="student-create-form">
            <h2>Yeni Öğrenci Ekle</h2>
            <label htmlFor="name">Ad</label>
            <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Ad" required/>
            <label htmlFor="lastName">Soyad</label>
            <input type="text" name="lastName" value={form.lastName} onChange={handleChange} placeholder="Soyad"
                   required/>
            <label htmlFor="email">Email</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email" required/>
            <label htmlFor="countryCode">Ülke Kodu</label>
            <select name="countryCode" value={form.countryCode} onChange={handleChange} required>
                <option value="+90">+90 (TR)</option>
                <option value="+1">+1 (US)</option>
                <option value="+44">+44 (UK)</option>
                <option value="+49">+49 (DE)</option>
                <option value="+33">+33 (FR)</option>
                {/* Diğer ülke kodları eklenebilir */}
            </select>
            <label htmlFor="phone">Telefon</label>
            <input type="text" name="phone" value={form.phone} onChange={handleChange} placeholder="Telefon" required/>
            <label htmlFor="password">Şifre</label>
            <input type="password" name="password" value={form.password} onChange={handleChange} placeholder="Şifre"
                   required/>
            <label htmlFor="isEnabled" style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <input type="checkbox" name="isEnabled" checked={form.isEnabled} onChange={handleChange}/>
                Aktif Olsun
            </label>
            <button type="submit">Kaydet</button>
        </form>
    );
}
